var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExporticon = function SvgExporticon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 17 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.256.8c.16 0 .32.08.4.16l4.08 4.16c.16.16.16.4 0 .56l-.56.56c-.08.16-.4.16-.56-.08l-2.72-2.72v8.16c0 .24-.16.4-.4.4h-.8c-.24 0-.4-.16-.4-.4V3.44l-2.72 2.72c-.16.16-.4.16-.56 0l-.56-.56a.387.387 0 0 1 0-.56L7.536.96c.08-.08.24-.16.4-.16h.32Zm7.04 10v2.8c0 .88-.72 1.6-1.6 1.6h-11.2c-.88 0-1.6-.72-1.6-1.6v-2.8c0-.24.16-.4.4-.4h.8c.24 0 .4.16.4.4v2.8h11.2v-2.8c0-.24.16-.4.4-.4h.8c.24 0 .4.16.4.4Z",
    clipRule: "evenodd"
  })));
};
export default SvgExporticon;